import { useToast } from 'context/providers/ToastProvider';
import useToken from 'hooks/useToken';
import React, { useEffect, useState, useContext } from 'react';
import useEstadoCuentaFiltros from './panel-estado-cuenta/useEstadoCuentaFiltros';
import { ContabilidadContext } from 'akasia-components/Contabilidad/common/ContabilidadContext';
import { ContabilidadLayout } from 'akasia-components/Contabilidad/common/ContabilidadLayout';
import { Card, Col, Row, Nav } from 'react-bootstrap';
import 'react-loading-skeleton/dist/skeleton.css';
import { useNavigate } from 'react-router-dom';
import ModalMapeoCSV from './ModalMapeoCSV';
import ModalMovimientoManual from './ModalMovimientoManual';
import ModalEliminarMovimientos from './ModalEliminarMovimientos';
import PanelEstadoCuenta from './panel-estado-cuenta/PanelEstadoCuenta';
import PanelFacturasConciliar from './panel-facturas-conciliar/PanelFacturasConciliar';
import ModalResultadosImportacion from './ModalResultadosImportacion';

const ConciliarFacturasContent = () => {

    //AUTENTICACION
    const { token, idCatTipoUsuario } = useToken();
    const { showErrorToast, showSuccessToast } = useToast();

    /**FILTROS GENERALES */
    const { selectedCompany } = useContext(ContabilidadContext);
    const rfcSeleccionado = selectedCompany?.vRFC || '';

    /**FILTROS ESTADO DE CUENTA */
    const {
        periodoEstadoCuenta,
        setPeriodoEstadoCuenta,
        tipoMovimiento,
        setTipoMovimiento,
        cuentaSeleccionada,
        setCuentaSeleccionada
    } = useEstadoCuentaFiltros();
    const [fechaInicialFacturas, setFechaInicialFacturas] = useState(() => {
        const d = new Date();
        d.setMonth(d.getMonth() - 1);
        return d;
    });
    const [fechaFinalFacturas, setFechaFinalFacturas] = useState(new Date());
    const [tipoDocumento, setTipoDocumento] = useState('');
    const [serieFactura, setSerieFactura] = useState('');
    const [cargando, setCargando] = useState(false);
    const [cargandoFacturas, setCargandoFacturas] = useState(false);
    const [showModalManual, setShowModalManual] = useState(false);
    const [mobileTab, setMobileTab] = useState('estadoCuenta');

    const [montoMinimo, setMontoMinimo] = useState('');
    const [montoMaximo, setMontoMaximo] = useState('');

    // Estado de cuenta
    const [movimientosBancarios, setMovimientosBancarios] = useState([]);
    const [movimientosFiltrados, setMovimientosFiltrados] = useState([]);

    // Facturas
    const [facturasFiltradas, setFacturasFiltradas] = useState([]);
    const [facturasSeleccionadas, setFacturasSeleccionadas] = useState([]);

    const [cargandoConciliacion, setCargandoConciliacion] = useState(false);

    // Estado para eliminación de movimientos
    const [movimientosSeleccionados, setMovimientosSeleccionados] = useState([]);
    const [showModalEliminar, setShowModalEliminar] = useState(false);

    // Modal de mapeo CSV
    const [showModalMapeo, setShowModalMapeo] = useState(false);
    const [datosCSV, setDatosCSV] = useState({ headers: [], rows: [] });
    const [mapeoColumnas, setMapeoColumnas] = useState({
        fecha: '',
        descripcion: '',
        cargo: '',
        abono: '',
        referencia: '',
        moneda: '',
        tipoCambio: ''
    });
    const [archivoTemporal, setArchivoTemporal] = useState(null);

    // Modal de resultados de importación
    const [showModalResultados, setShowModalResultados] = useState(false);
    const [resultadosImportacion, setResultadosImportacion] = useState([]);

    // Configuración adicional para el modal
    const [cuentasBancarias, setCuentasBancarias] = useState([]);

    const navigate = useNavigate();

    useEffect(() => {
        if (idCatTipoUsuario != 1) {
            navigate("/");
        }
        checkPermisos();
        cargarCuentasBancarias();
    }, []);

    /**
     * Aplica filtros cuando cambian
     */
    useEffect(() => {
        aplicarFiltrosMovimientos();
    }, [tipoMovimiento, periodoEstadoCuenta, movimientosBancarios, rfcSeleccionado]);

    useEffect(() => {
        if (rfcSeleccionado) {
            cargarCuentasBancarias();
        } else {
            setFacturasFiltradas([]);
            setCuentasBancarias([]);
        }
    }, [rfcSeleccionado]);

    useEffect(() => {
        const timer = setTimeout(() => {
            if (rfcSeleccionado) {
                obtenerFacturas();
            } else {
                setFacturasFiltradas([]);
            }
        }, 500);
        return () => clearTimeout(timer);
    }, [tipoDocumento, tipoMovimiento, fechaInicialFacturas, fechaFinalFacturas, rfcSeleccionado, cuentaSeleccionada, cuentasBancarias, montoMinimo, montoMaximo, movimientosSeleccionados, serieFactura]);

    useEffect(() => {
        if (cuentaSeleccionada && periodoEstadoCuenta) {
            obtenerMovimientosBancarios();
        } else {
            setMovimientosBancarios([]);
            setMovimientosFiltrados([]);
        }
    }, [cuentaSeleccionada, periodoEstadoCuenta]);

    // Sincronizar fechas de facturas con el periodo del estado de cuenta
    useEffect(() => {
        if (periodoEstadoCuenta) {
            const year = periodoEstadoCuenta.getFullYear();
            const month = periodoEstadoCuenta.getMonth();
            const firstDay = new Date(year, month, 1);
            const lastDay = new Date(year, month + 1, 0);
            setFechaInicialFacturas(firstDay);
            setFechaFinalFacturas(lastDay);
        }
    }, [periodoEstadoCuenta]);

    /**
    * Verifica los permisos
    */
    const checkPermisos = async () => {
        const response = await fetch("/api/Administradores/checkPermisos",
            {
                method: 'POST',
                headers:
                {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            }).catch((error) => {
                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
            });

        if (response.ok) {
            const responseType = await response.json();


            if (responseType.iResponseType == 1) {
                // Permisos verificados
            } else {
                navigate("/");
            }
        }
        else {
            navigate("/");
        }
    }

    const idDatoFiscalSeleccionado = selectedCompany?.idDatoFiscal || null;

    /**
     * Carga el catálogo de cuentas bancarias
     */
    const cargarCuentasBancarias = async () => {
        if (!rfcSeleccionado || !idDatoFiscalSeleccionado) {
            setCuentasBancarias([]);
            return;
        }
        try {
            const response = await fetch("/api/contabilidad/bancos/CuentasBancarias/ObtenerCuentas", {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ idDatoFiscal: idDatoFiscalSeleccionado })
            });

            if (response.ok) {
                const resultado = await response.json();

                if (resultado.iResponseType === 1) {
                    const cuentas = JSON.parse(resultado.detalles || "[]");
                    setCuentasBancarias(cuentas);
                } else {
                    showErrorToast('No se pudieron cargar las cuentas bancarias');
                }
            }
        } catch (error) {
            console.error('Error al cargar cuentas bancarias:', error);
            showErrorToast('Error al cargar cuentas bancarias');
        }
    };

    /**
     * Aplica filtros a los movimientos bancarios
     */
    const aplicarFiltrosMovimientos = () => {
        let movimientosFiltrados = [...movimientosBancarios];

        if (tipoMovimiento) {
            movimientosFiltrados = movimientosFiltrados.filter(m => m.tipo === tipoMovimiento);
        }

        setMovimientosFiltrados(movimientosFiltrados);
    };

    /**
     * Obtiene facturas desde el backend
     */
    const obtenerFacturas = async () => {
        try {
            setCargandoFacturas(true);
            const formattedFechaInicial = fechaInicialFacturas.toISOString().split('T')[0];
            const formattedFechaFinal = fechaFinalFacturas.toISOString().split('T')[0];

            const cuenta = cuentasBancarias.find(c => c.idCatCuentaBancaria.toString() === cuentaSeleccionada.toString());
            const monedaCuenta = cuenta?.vMoneda || "";

            const response = await fetch('/api/contabilidad/bancos/Conciliacion/ObtenerFacturasConciliacion', {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    rfc: rfcSeleccionado,
                    fechaInicial: formattedFechaInicial,
                    fechaFinal: formattedFechaFinal,
                    tipoDocumento: tipoDocumento || "",
                    tipoMovimiento: tipoMovimiento || "",
                    moneda: monedaCuenta,
                    montoMinimo: montoMinimo !== '' ? parseFloat(montoMinimo) : null,
                    montoMaximo: montoMaximo !== '' ? parseFloat(montoMaximo) : null
                })
            });

            if (response.ok) {
                const data = await response.json();
                if (data.iResponseType === 1) {
                    let facturasObtenidas = JSON.parse(data.detalles || "[]");
                    if (serieFactura.trim() !== '') {
                        facturasObtenidas = facturasObtenidas.filter(f => f.serie && f.serie.toLowerCase().includes(serieFactura.toLowerCase().trim()));
                    }
                    setFacturasFiltradas(facturasObtenidas);
                } else {
                    showErrorToast(data.vMessage || 'Error al obtener facturas');
                    setFacturasFiltradas([]);
                }
            } else {
                showErrorToast('Error al obtener facturas');
                setFacturasFiltradas([]);
            }
        } catch (error) {
            console.error(error);
            showErrorToast('Error al conectar con el servidor');
            setFacturasFiltradas([]);
        } finally {
            setCargandoFacturas(false);
        }
    };

    /**
     * Obtiene los movimientos bancarios de la BD para la cuenta seleccionada
     */
    const obtenerMovimientosBancarios = async () => {
        if (!cuentaSeleccionada) return;
        try {
            setCargando(true);
            const month = (periodoEstadoCuenta.getMonth() + 1).toString().padStart(2, '0');
            const year = periodoEstadoCuenta.getFullYear().toString();

            const response = await fetch('/api/contabilidad/bancos/Conciliacion/ObtenerMovimientosBancarios', {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    idCatCuentaBancaria: cuentaSeleccionada,
                    month: month,
                    year: year
                })
            });

            if (response.ok) {
                const data = await response.json();
                if (data.iResponseType === 1) {
                    const movs = JSON.parse(data.detalles || "[]");
                    setMovimientosBancarios(movs);
                } else {
                    showErrorToast(data.vMessage || 'Error al obtener movimientos bancarios');
                    setMovimientosBancarios([]);
                }
            } else {
                showErrorToast('Error al obtener movimientos bancarios');
                setMovimientosBancarios([]);
            }
        } catch (error) {
            console.error(error);
            showErrorToast('Error al conectar con el servidor (Movimientos)');
            setMovimientosBancarios([]);
        } finally {
            setCargando(false);
        }
    };

    /**
     * Lee y parsea el archivo CSV para mostrar en el modal
     */
    const leerArchivoCSV = (file) => {
        const reader = new FileReader();

        reader.onload = (e) => {
            try {
                const text = e.target.result;
                const lines = text.split('\n').filter(line => line.trim() !== '');

                if (lines.length === 0) {
                    showErrorToast("El archivo CSV está vacío");
                    return;
                }

                const headers = lines[0].split(',').map(h => h.trim());

                const rows = lines.slice(1, Math.min(6, lines.length)).map(line => {
                    return line.split(',').map(cell => cell.trim());
                });

                setDatosCSV({ headers, rows });

                const mapeoAuto = mapeoAutomaticoColumnas(headers);
                setMapeoColumnas(mapeoAuto);

                setArchivoTemporal(file);
                setShowModalMapeo(true);
            } catch (error) {
                showErrorToast("Error al leer el archivo CSV: " + error.message);
            }
        };

        reader.onerror = () => {
            showErrorToast("Error al leer el archivo");
        };

        reader.readAsText(file, 'UTF-8');
    };

    /**
     * Mapeo automático inteligente de columnas
     */
    const mapeoAutomaticoColumnas = (headers) => {
        const mapeo = {
            fecha: '',
            descripcion: '',
            cargo: '',
            abono: '',
            referencia: ''
        };

        headers.forEach((header, index) => {
            const headerLower = header.toLowerCase();

            if (headerLower.includes('fecha') || headerLower.includes('date')) {
                mapeo.fecha = index.toString();
            }

            if (headerLower.includes('descripcion') || headerLower.includes('concepto') ||
                headerLower.includes('description') || headerLower.includes('detalle')) {
                mapeo.descripcion = index.toString();
            }

            if (headerLower.includes('cargo') || headerLower.includes('retiro') ||
                headerLower.includes('egreso') || headerLower.includes('amount') || headerLower.includes('withdraw') || headerLower.includes('pagos')) {
                mapeo.cargo = index.toString();
            }

            if (headerLower.includes('abono') || headerLower.includes('deposito') ||
                headerLower.includes('ingreso') || headerLower.includes('deposit')) {
                mapeo.abono = index.toString();
            }

            if (headerLower.includes('referencia') || headerLower.includes('reference') ||
                headerLower.includes('ref')) {
                mapeo.referencia = index.toString();
            }
        });

        return mapeo;
    };

    /**
     * Maneja la selección inicial del archivo
     */
    const handleSeleccionarArchivo = (e) => {
        const file = e.target.files[0];

        if (!file) {
            return;
        }

        if (!rfcSeleccionado) {
            showErrorToast("Debe seleccionar un RFC antes de importar");
            e.target.value = '';
            return;
        }

        const extension = file.name.split('.').pop().toLowerCase();
        if (extension !== 'csv') {
            showErrorToast("Solo se permiten archivos CSV");
            e.target.value = '';
            return;
        }

        if (file.size > 5 * 1024 * 1024) {
            showErrorToast("El archivo no debe superar los 5MB");
            e.target.value = '';
            return;
        }

        leerArchivoCSV(file);

        e.target.value = '';
    };

    /**
     * Confirma el mapeo y procesa la importación
     */
    const confirmarImportacion = async () => {
        const camposObligatorios = ['fecha', 'descripcion', 'referencia'];
        const camposFaltantes = camposObligatorios.filter(campo => !mapeoColumnas[campo]);

        if (camposFaltantes.length > 0) {
            showErrorToast(`Debe mapear los siguientes campos obligatorios: ${camposFaltantes.join(', ')}`);
            return;
        }

        if (!mapeoColumnas.cargo && !mapeoColumnas.abono) {
            showErrorToast('Debe mapear al menos la columna de Cargo o la de Abono');
            return;
        }

        try {
            setCargando(true);
            setShowModalMapeo(false);

            const formData = new FormData();
            formData.append('file', archivoTemporal);
            formData.append('rfcEmisor', rfcSeleccionado);
            formData.append('idCatCuentaBancaria', cuentaSeleccionada);
            formData.append('mapeoColumnas', JSON.stringify(mapeoColumnas));

            const response = await fetch('/api/contabilidad/bancos/Conciliacion/ImportarEstadoCuenta', {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token
                },
                body: formData
            });

            if (response.ok) {
                const resultado = await response.json();

                if (resultado.iResponseType === 1) {
                    if (resultado.detalles) {
                        try {
                            let detallesStr = resultado.detalles;
                            // Reparar el JSON si el backend destruyó los corchetes
                            if (typeof detallesStr === 'string' && !detallesStr.trim().startsWith('[')) {
                                detallesStr = '[' + detallesStr + ']';
                            }
                            const detallesParseados = JSON.parse(detallesStr);
                            setResultadosImportacion(detallesParseados);
                            setShowModalResultados(true);
                        } catch (e) {
                            console.error("Error parseando detalles", e);
                            showSuccessToast(resultado.vMessage);
                        }
                    } else {
                        showSuccessToast(resultado.vMessage);
                    }
                    aplicarFiltrosMovimientos();
                } else {
                    showErrorToast(resultado.vMessage);
                }
            } else {
                showErrorToast(`Error al importar: ${response.status} ${response.statusText}`);
            }
        } catch (error) {
            console.error('Error al importar estado de cuenta:', error);
            showErrorToast('Error al procesar el archivo: ' + error.message);
        } finally {
            setCargando(false);
            setArchivoTemporal(null);
        }
    };

    /**
     * Eliminar movimientos seleccionados
     */
    const eliminarMovimientosBancarios = async () => {
        try {
            setCargando(true);
            const ids = movimientosSeleccionados.map(m => m.id).join(',');

            const formData = new FormData();
            formData.append('idsMovimientos', ids);

            const response = await fetch('/api/contabilidad/bancos/Conciliacion/EliminarMovimientosBancarios', {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token
                },
                body: formData
            });

            if (response.ok) {
                const resultado = await response.json();
                if (resultado.iResponseType === 1) {
                    showSuccessToast(resultado.vMessage);
                    setShowModalEliminar(false);
                    setMovimientosSeleccionados([]);
                    obtenerMovimientosBancarios();
                } else {
                    showErrorToast(resultado.vMessage);
                }
            } else {
                showErrorToast(`Error al eliminar: ${response.status}`);
            }
        } catch (error) {
            console.error('Error al eliminar movimientos:', error);
            showErrorToast('Error de red al intentar eliminar.');
        } finally {
            setCargando(false);
        }
    };

    /**
     * Desconcilia un movimiento bancario
     */
    const desconciliarMovimientoBancario = async (movimiento) => {
        if (!movimiento || !movimiento.id) return;

        setCargando(true);
        try {
            const dataToPost = { idMovimientoBancario: movimiento.id };

            const response = await fetch('/api/contabilidad/bancos/Conciliacion/DesconciliarMovimientoBancario', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + token
                },
                body: JSON.stringify(dataToPost)
            });

            if (response.ok) {
                const resultado = await response.json();
                if (resultado.iResponseType === 1) {
                    showSuccessToast(resultado.vMessage);
                    obtenerMovimientosBancarios();
                } else {
                    showErrorToast(resultado.vMessage);
                }
            } else {
                showErrorToast(`Error de servidor: ${response.status}`);
            }
        } catch (error) {
            console.error('Error al desconciliar:', error);
            showErrorToast('Error de red al intentar desconciliar.');
        } finally {
            setCargando(false);
        }
    };

    /**
     * Cancela el modal de mapeo
     */
    const cancelarMapeo = () => {
        setShowModalMapeo(false);
        setArchivoTemporal(null);
        setDatosCSV({ headers: [], rows: [] });
        setMapeoColumnas({
            fecha: '',
            descripcion: '',
            monto: '',
            tipo: '',
            referencia: '',
            moneda: '',
            tipoCambio: ''
        });
        setCuentaSeleccionada('');
    };

    /**
     * Genera y descarga el reporte PDF de conciliación
     */
    const handleGenerarReportePDF = async () => {
        if (!rfcSeleccionado || !cuentaSeleccionada || !periodoEstadoCuenta) {
            showErrorToast('Debe seleccionar empresa, cuenta y periodo para generar el reporte');
            return;
        }

        try {
            setCargando(true);
            const month = (periodoEstadoCuenta.getMonth() + 1).toString().padStart(2, '0');
            const year = periodoEstadoCuenta.getFullYear().toString();

            const response = await fetch('/api/contabilidad/bancos/Conciliacion/GenerarReporteConciliacionPDF', {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    rfc: rfcSeleccionado,
                    idCatCuentaBancaria: cuentaSeleccionada,
                    month: month,
                    year: year
                })
            });

            if (response.ok) {
                const blob = await response.blob();
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `ReporteConciliacion_${month}_${year}.pdf`;
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);
                showSuccessToast('Reporte generado correctamente');
            } else {
                await response.text();
                showErrorToast('Error al generar el reporte PDF');
            }
        } catch (error) {
            console.error('Error al generar el reporte:', error);
            showErrorToast('Error de red al intentar generar el reporte.');
        } finally {
            setCargando(false);
        }
    };

    const toggleSeleccionFactura = (factura) => {
        setFacturasSeleccionadas(prev => {
            const isSelected = prev.some(f => f.id === factura.id);
            if (isSelected) {
                return prev.filter(f => f.id !== factura.id);
            } else {
                return [...prev, factura];
            }
        });
    };

    const totalFacturasSeleccionadas = facturasSeleccionadas.reduce((sum, f) => {
        const total = f.tipo === 'E' ? -Math.abs(f.total) : f.total;
        const totalMXN = total * (f.tipoCambio || 1);
        return sum + totalMXN;
    }, 0);

    const conciliarMovimientosYFacturas = async (facturaDirecta = null) => {
        const facturaAConciliar = facturaDirecta && facturaDirecta.id ? facturaDirecta : (facturasSeleccionadas.length === 1 ? facturasSeleccionadas[0] : null);

        if (movimientosSeleccionados.length !== 1 || !facturaAConciliar) {
            showErrorToast('Debe seleccionar exactamente un movimiento y una factura para conciliar');
            return;
        }

        try {
            setCargandoConciliacion(true);

            const response = await fetch('/api/contabilidad/bancos/Conciliacion/ConciliarMovimientosYFacturas', {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    idMovimiento: movimientosSeleccionados[0].id,
                    idFactura: facturaAConciliar.id,
                    tipoFactura: facturaAConciliar.tipo
                })
            });

            if (response.ok) {
                const resultado = await response.json();
                if (resultado.iResponseType === 1) {
                    showSuccessToast(resultado.vMessage);
                    const movId = movimientosSeleccionados[0].id;
                    const factId = facturaAConciliar.id;

                    setFacturasFiltradas(prev => prev.filter(f => f.id !== factId));
                    
                    setMovimientosBancarios(prev => prev.map(m => {
                        if (m.id === movId) {
                            const totalFacturaMXN = Number((facturaAConciliar.total * (facturaAConciliar.tipoCambio || 1)).toFixed(2));
                            let nuevoMonto = Number((m.monto - totalFacturaMXN).toFixed(2));
                            if (nuevoMonto <= 0) nuevoMonto = 0;
                            
                            let nuevoConciliado = Number(((m.montoConciliado || 0) + totalFacturaMXN).toFixed(2));
                            const montoOriginal = Number((m.montoOriginal || (m.monto + (m.montoConciliado || 0))).toFixed(2));
                            if (nuevoConciliado > montoOriginal) nuevoConciliado = montoOriginal;
                            
                            return { 
                                ...m, 
                                monto: nuevoMonto, 
                                montoConciliado: nuevoConciliado,
                                montoOriginal: montoOriginal
                            };
                        }
                        return m;
                    }));

                    setMovimientosSeleccionados([]);
                    setFacturasSeleccionadas([]);
                    setMontoMinimo('');
                    setMontoMaximo('');
                    setMobileTab('estadoCuenta');
                } else {
                    showErrorToast(resultado.vMessage);
                }
            } else {
                showErrorToast(`Error al conciliar: ${response.status}`);
            }
        } catch (error) {
            console.error('Error al conciliar:', error);
            showErrorToast('Error de red al intentar conciliar.');
        } finally {
            setCargandoConciliacion(false);
        }
    };

    const toggleSeleccionMovimiento = (movimiento) => {
        setMovimientosSeleccionados(prev => {
            const exists = prev.some(m => m.id === movimiento.id);
            if (exists) {
                const updated = prev.filter(m => m.id !== movimiento.id);
                if (updated.length === 0) {
                    setMontoMinimo('');
                    setMontoMaximo('');
                    setTimeout(() => setMobileTab('estadoCuenta'), 0);
                }
                return updated;
            } else {
                setMontoMinimo(movimiento.monto);
                setMontoMaximo(movimiento.monto);
                setTimeout(() => setMobileTab('facturas'), 0);
                return [...prev, movimiento];
            }
        });
    };

    const toggleSeleccionTodos = (seleccionarTodos) => {
        if (seleccionarTodos) {
            setMovimientosSeleccionados([...movimientosFiltrados]);
            setMontoMinimo('');
            setMontoMaximo('');
        } else {
            setMovimientosSeleccionados([]);
            setMontoMinimo('');
            setMontoMaximo('');
        }
    };

    return (
        <>
            {!rfcSeleccionado && (
                <Card className="mb-3 shadow-sm border-warning">
                    <Card.Body className="p-3 bg-soft-warning">
                        <div className="d-flex align-items-center">
                            <i className="fas fa-exclamation-triangle fa-2x text-warning me-3"></i>
                            <div>
                                <h6 className="mb-1 text-warning-dark">Atención: No hay empresa seleccionada</h6>
                                <p className="mb-0 fs--1 text-800">Por favor, seleccione una empresa en la parte superior para visualizar los movimientos bancarios y facturas correspondientes.</p>
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            )}

            <ModalMovimientoManual
                show={showModalManual}
                onHide={() => setShowModalManual(false)}
                rfcSeleccionado={rfcSeleccionado}
                idDatoFiscal={idDatoFiscalSeleccionado}
                onSuccess={() => {
                    cargarCuentasBancarias();
                    obtenerMovimientosBancarios();
                }}
            />

            <ModalMapeoCSV
                show={showModalMapeo}
                onHide={cancelarMapeo}
                onConfirm={confirmarImportacion}
                datosCSV={datosCSV}
                mapeoColumnas={mapeoColumnas}
                setMapeoColumnas={setMapeoColumnas}
                cuentasBancarias={cuentasBancarias}
                cuentaSeleccionada={cuentaSeleccionada}
                setCuentaSeleccionada={setCuentaSeleccionada}
            />

            <ModalEliminarMovimientos
                show={showModalEliminar}
                handleClose={() => setShowModalEliminar(false)}
                movimientosSeleccionados={movimientosSeleccionados}
                eliminarMovimientos={eliminarMovimientosBancarios}
                cargando={cargando}
            />

            <ModalResultadosImportacion
                show={showModalResultados}
                handleClose={() => setShowModalResultados(false)}
                resultados={resultadosImportacion}
            />

            {/* Navegación para móvil */}
            <div className="d-lg-none mb-3">
                <Nav variant="pills" className="nav-fill bg-light rounded shadow-sm p-1">
                    <Nav.Item>
                        <Nav.Link 
                            active={mobileTab === 'estadoCuenta'} 
                            onClick={() => setMobileTab('estadoCuenta')}
                            className="fw-semi-bold rounded"
                        >
                            <i className="fas fa-list-ul me-2"></i>Estado de Cuenta
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link 
                            active={mobileTab === 'facturas'} 
                            onClick={() => setMobileTab('facturas')}
                            className="fw-semi-bold rounded"
                        >
                            <i className="fas fa-file-invoice-dollar me-2"></i>Facturas
                        </Nav.Link>
                    </Nav.Item>
                </Nav>
            </div>

            {/* Sección Principal: Estado de Cuenta y Facturas */}
            <Row className="g-3">
                {/* Columna Izquierda: Estado de Cuenta */}
                <Col lg={6} className={mobileTab === 'estadoCuenta' ? '' : 'd-none d-lg-block'}>
                    <PanelEstadoCuenta
                        rfcSeleccionado={rfcSeleccionado}
                        cargando={cargando}
                        periodoEstadoCuenta={periodoEstadoCuenta}
                        setPeriodoEstadoCuenta={setPeriodoEstadoCuenta}
                        tipoMovimiento={tipoMovimiento}
                        setTipoMovimiento={setTipoMovimiento}
                        movimientosFiltrados={movimientosFiltrados}
                        handleSeleccionarArchivo={handleSeleccionarArchivo}
                        onAgregarManual={() => setShowModalManual(true)}
                        cuentasBancarias={cuentasBancarias}
                        cuentaSeleccionada={cuentaSeleccionada}
                        setCuentaSeleccionada={setCuentaSeleccionada}
                        movimientosSeleccionados={movimientosSeleccionados}
                        toggleSeleccionMovimiento={toggleSeleccionMovimiento}
                        toggleSeleccionTodos={toggleSeleccionTodos}
                        setShowModalEliminar={setShowModalEliminar}
                        onDesconciliar={desconciliarMovimientoBancario}
                        cargandoConciliacion={cargandoConciliacion}
                        handleGenerarReportePDF={handleGenerarReportePDF}
                    />
                </Col>

                {/* Columna Derecha: Facturas */}
                <Col lg={6} className={mobileTab === 'facturas' ? '' : 'd-none d-lg-block'}>
                    <PanelFacturasConciliar
                        rfcSeleccionado={rfcSeleccionado}
                        cargandoFacturas={cargandoFacturas}
                        facturasFiltradas={facturasFiltradas}
                        facturasSeleccionadas={facturasSeleccionadas}
                        setFacturasSeleccionadas={setFacturasSeleccionadas}
                        totalFacturasSeleccionadas={totalFacturasSeleccionadas}
                        toggleSeleccionFactura={toggleSeleccionFactura}
                        fechaInicialFacturas={fechaInicialFacturas}
                        setFechaInicialFacturas={setFechaInicialFacturas}
                        fechaFinalFacturas={fechaFinalFacturas}
                        setFechaFinalFacturas={setFechaFinalFacturas}
                        tipoDocumento={tipoDocumento}
                        setTipoDocumento={setTipoDocumento}
                        serieFactura={serieFactura}
                        setSerieFactura={setSerieFactura}
                        montoMinimo={montoMinimo}
                        setMontoMinimo={setMontoMinimo}
                        montoMaximo={montoMaximo}
                        setMontoMaximo={setMontoMaximo}
                        movimientosSeleccionados={movimientosSeleccionados}
                        onConciliar={conciliarMovimientosYFacturas}
                        cargandoConciliacion={cargandoConciliacion}
                    />
                </Col>
            </Row>
        </>
    );
};

const ConciliarFacturas = () => {
    return (
        <ContabilidadLayout
            title={
                <><i className="fas fa-file-invoice-dollar me-2" />Conciliación de Facturas</>
            }
        >
            <ConciliarFacturasContent />
        </ContabilidadLayout>
    );
};

export default ConciliarFacturas;




